import React, { Component } from 'react';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Input from 'components/react-validation/components/input';
import { Modal } from 'react-bootstrap';
import * as Vali from 'helper/validator-helper';
import PropTypes from 'prop-types';
import * as ItemRepairActionType from '../constants';

export class AddProblemModal extends Component {
  static propTypes = {
    isOpenFormAddEdit: PropTypes.bool,
    isCreate: PropTypes.bool,
    isOpen: PropTypes.bool,
    errorMsg: PropTypes.array,
    selectListItem: PropTypes.array,
    onSubmit: PropTypes.func,
    closeModal: PropTypes.func,
    item: PropTypes.object,
    title: PropTypes.string,
    itemId: PropTypes.number,
    problem: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: null
    };
  }
  componentDidMount() {
    if (this.form) {

      this.form.resetForm(this.refs);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.form) {
      this.form.resetForm(this.refs);
    }
    if (nextProps.errorMsg.length > 0 && this.form) {
      this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
    }
  }

  mapParam() {
    let param = this.form.getValues();
    return param;
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (this.props.isCreate) {
      this.props.onSubmit(e,
        this.mapParam(),
        ItemRepairActionType.CREATE_PROBLEM_ASYNC);
    } else {
      this.props.onSubmit(e,
        this.mapParam(),
        ItemRepairActionType.UPDATE_PROBLEM_ASYNC);
    }
  }

  render() {
    let name = '';

    if (this.props.problem) {
      name = this.props.problem.name;
    }

    if (this.form && this.form.getValues().name) {
      name = this.form.getValues().name;
    }

    return (
      <div className=''>
        <Modal show={this.props.isOpen}>
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>{this.props.title}</Modal.Title>
            <button className='close' onClick={this.props.closeModal} >&times;</button>
          </Modal.Header>
          <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
            <Modal.Body>
              {this.props.problem &&
              <Input type='hidden' name='id' ref='id' value={this.props.problem.id} />
              }

              {/*<Input type='hidden' name='isActive' ref='isActive' value={this.props.item.isActive} />*/}
              <div className='form-group'>
                <label>Item to repair:</label>
                <strong style={{wordBreak: 'break-all'}}>{' ' + this.props.item.description}</strong>
              </div>
              <div className='form-group'>
                <label>Problem name <strong className='text-danger'>*</strong></label>
                <Input
                  name='name'
                  ref='name'
                  value={name}
                  placeholder='name'
                  className='form-control'
                  autoFocus
                  max='100'
                  maxLength='100'
                  validations={[Vali.required, Vali.maxlength]} />
              </div>
            </Modal.Body>
            <Modal.Footer >
              <Submit className='btn btn-primary btn-siteone'>Done</Submit>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Items/Components/add-problem-modal.js